import { render, staticRenderFns } from "./recordByVoice.vue?vue&type=template&id=19297d87&scoped=true"
import script from "./recordByVoice.vue?vue&type=script&lang=js"
export * from "./recordByVoice.vue?vue&type=script&lang=js"
import style0 from "./recordByVoice.vue?vue&type=style&index=0&id=19297d87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19297d87",
  null
  
)

export default component.exports